import React, { useState } from 'react';
import { Typography, TypographyProps, Link } from '@material-ui/core';
import { sliceWords } from '../../utils/text-formatting';

interface Props {
  maxNumberOfWords: number;
  onExpand?: () => void;
}

export const CollapsedText: React.FC<Props & TypographyProps> = ({
  maxNumberOfWords,
  onExpand,
  ...props
}) => {
  const [collapsed, setCollapsed] = useState(true);
  const slicedText = sliceWords(props.children as string, maxNumberOfWords);

  const handleMore = () => {
    setCollapsed(false)
    onExpand && onExpand()
  }

  if (collapsed) {
    return (
      <Typography {...props}>
        {slicedText}
        <Link
          variant="subtitle1"
          component="button"
          underline="none"
          onClick={handleMore}
        >
          ...more
        </Link>
      </Typography>
    );
  }

  return <Typography {...props} />;
};
